import Vue from "vue";
import App from "./App.vue";
import "./main.css";
import 'lib-flexible';
import '@/css/font.css';

Vue.config.productionTip = false;

window.eventBus = new Vue();

new Vue({
  render: h => h(App)
}).$mount("#app");
